// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.result-container {
  background-color: #f5f5f5;
  margin-top: 30px;
}

.top-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.flex-block {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.table-main-header__header-name {
  display: flex;
  align-items: center;
  display: flex;
}

.table-main-header__header-name--search {
  justify-content: space-between;
}

.table-main-header__header-summary {
  margin: 0;
  padding: 0;
  justify-content: center;
  align-items: center;
  display: flex;
}

.table-main-header__search {
  padding: 5px 10px;
}

.flex-block div:nth-child(1) {
  width: 15%;
  padding-right: 5px;
}

.flex-block div:nth-child(2) {
  width: 15%;
}

.flex-block div:nth-child(3) {
  width: 15%;
}

.flex-block div:nth-child(4) {
  width: 55%;
}

.table-main-header {
  font-size: 14px;
  font-weight: 500;
  padding: 1rem 1.77rem;
}

.table-main-body {
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  border-top: 1px solid rgba(0, 0, 0, 0.3);
}

.body__item {
  font-size: 14px;
  padding: 5px 0;
}

.body__item.filename {
  color: #fa332a !important;
  position: relative;
  overflow: hidden;
}

.body__item.filename.open {
  color: #fa332a !important;
  position: relative;
  text-decoration: underline;
}

.body__item.filename.open.no-url {
  text-decoration: none;
}

img {
  margin-right: 5px;
}

.empty {
  text-align: center;
}

.accordion-button::after {
  left: 0;
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 7px;
  left: 0px;
  transform-origin: center;
  background-position: center;
  transform: rotate(90deg);
}

.body__item.filename.body::after {
  height: 11px;
  width: 7px;
  content: "";
  left: 0;
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 7px;
  left: -14px;
  top: 8px;
  transform-origin: center;
  background-position: center;
  transform: rotate(0deg);
}

.accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  transform: rotate(0deg);
}

.accordion-button:not(.collapsed) {
  color: black;
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/TryIt/Result/Result.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,yDAAgD;EAChD,oBAAoB;EACpB,SAAS;EACT,wBAAwB;EACxB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,yDAAgD;EAChD,oBAAoB;EACpB,WAAW;EACX,QAAQ;EACR,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,yDAAgD;EAChD,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":[".result-container {\n  background-color: #f5f5f5;\n  margin-top: 30px;\n}\n\n.top-block {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.flex-block {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.table-main-header__header-name {\n  display: flex;\n  align-items: center;\n  display: flex;\n}\n\n.table-main-header__header-name--search {\n  justify-content: space-between;\n}\n\n.table-main-header__header-summary {\n  margin: 0;\n  padding: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n\n.table-main-header__search {\n  padding: 5px 10px;\n}\n\n.flex-block div:nth-child(1) {\n  width: 15%;\n  padding-right: 5px;\n}\n\n.flex-block div:nth-child(2) {\n  width: 15%;\n}\n\n.flex-block div:nth-child(3) {\n  width: 15%;\n}\n\n.flex-block div:nth-child(4) {\n  width: 55%;\n}\n\n.table-main-header {\n  font-size: 14px;\n  font-weight: 500;\n  padding: 1rem 1.77rem;\n}\n\n.table-main-body {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n}\n\n.body__item {\n  font-size: 14px;\n  padding: 5px 0;\n}\n\n.body__item.filename {\n  color: #fa332a !important;\n  position: relative;\n  overflow: hidden;\n}\n\n.body__item.filename.open {\n  color: #fa332a !important;\n  position: relative;\n  text-decoration: underline;\n}\n\n.body__item.filename.open.no-url {\n  text-decoration: none;\n}\n\nimg {\n  margin-right: 5px;\n}\n\n.empty {\n  text-align: center;\n}\n\n.accordion-button::after {\n  left: 0;\n  position: absolute;\n  background-image: url(../../../assets/arrow.svg);\n  background-size: 7px;\n  left: 0px;\n  transform-origin: center;\n  background-position: center;\n  transform: rotate(90deg);\n}\n\n.body__item.filename.body::after {\n  height: 11px;\n  width: 7px;\n  content: \"\";\n  left: 0;\n  position: absolute;\n  background-image: url(../../../assets/arrow.svg);\n  background-size: 7px;\n  left: -14px;\n  top: 8px;\n  transform-origin: center;\n  background-position: center;\n  transform: rotate(0deg);\n}\n\n.accordion-button:not(.collapsed)::after {\n  background-image: url(../../../assets/arrow.svg);\n  transform: rotate(0deg);\n}\n\n.accordion-button:not(.collapsed) {\n  color: black;\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
